<template>
  <div class="home w_main">
    <!-- 首页顶部 登录 -->
    <div class="form-warp">
      <!-- 背景图 -->
      <img class="bg_image" src="../assets/demoImg/bg.png" alt="banner">
      <!-- 菜单框 -->
      <div class="box">
        <div class="flex">
          <el-image class="tx_img" v-if="user.hasLogin" :src="user.avatar" fit="cover"></el-image>
          <el-image v-else class="tx_img" :src="require('../assets/image/tx.png')" fit="fill"></el-image>
          <div class="info_box text_left">
            <p>Hi,<span v-if="user.hasLogin">{{ user.name }}</span> 你好</p>
            <p>欢迎访问在线培训平台</p>
          </div>
        </div>
        <el-button class="btn" type="primary" round @click="jumpPage(3)">访问学习中心</el-button>
        <div>
          <el-row :gutter="10" class="mt15">
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(1)">
                <img class="icon_menu" src="../assets/image/pxbm.png" alt="培训报名">
                <p class="menu_name">培训报名</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(2)">
                <img class="icon_menu" src="../assets/image/zxzf.png" alt="在线支付">
                <p class="menu_name">在线支付</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(3)">
                <img class="icon_menu" src="../assets/image/zxxx.png" alt="在线学习">
                <p class="menu_name">在线学习</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(4)">
                <img class="icon_menu" src="../assets/image/pxda.png" alt="培训档案">
                <p class="menu_name">培训档案</p>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" class="mt10">
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(5)">
                <img class="icon_menu" src="../assets/image/wddd.png" alt="我的订单">
                <p class="menu_name">我的订单</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(6)">
                <img class="icon_menu" src="../assets/image/wdfp.png" alt="我的发票">
                <p class="menu_name">我的发票</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(7)">
                <img class="icon_menu" src="../assets/image/grsz.png" alt="个人设置">
                <p class="menu_name">个人设置</p>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="grid-content bai-xf" @click="jumpPage(8)">
                <img class="icon_menu" src="../assets/image/zxfk.png" alt="咨询反馈">
                <p class="menu_name">咨询反馈</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 热门培训项目 -->
    <div class="bai-card mt20">
      <div class="title">
        <span class="gang"></span>
        <p class="txt">热门培训项目</p>
      </div>
      <div class="content">
        <div class="bz_box">
          <el-row>
            <el-col :span="3">
              <div class="bz_item">1 选择培训项目</div>
            </el-col>
            <el-col :span="1">
              <div class="bz_item_icon">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="bz_item">2 添加报名人员</div>
            </el-col>
            <el-col :span="1">
              <div class="bz_item_icon">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="bz_item">3 在线支付</div>
            </el-col>
            <el-col :span="1">
              <div class="bz_item_icon">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="bz_item">4 在线视频学习</div>
            </el-col>
            <el-col :span="1">
              <div class="bz_item_icon">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="bz_item">5 在线考试</div>
            </el-col>
            <el-col :span="1">
              <div class="bz_item_icon">
                <i class="el-icon-d-arrow-right"></i>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="bz_item">6 打印培训证明</div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <!-- 热门培训项目 -->
    <div v-for="(courses, typeId) in courseList" :key="typeId" class="bai-card mt20">
      <div class="title spaceBetween">
        <div class="flex align_center">
          <span class="gang"></span>
          <p class="txt">{{ typeId + '' === '0' ? '热门培训项目' : `${courses[0].workType}` }}</p>
        </div>
        <p class="more more-button bai-xf" @click="jumpPage(1)">MORE+</p>
      </div>
      <div class="content product-list">
        <div class="goods_item bai-xf" v-for="(item, index) in courses" :key="item.id">
          <div class="mask">
            <el-button type="primary" @click="jumpCouerDetalis(item)">查看课程详情</el-button>
          </div>
          <div class="img_box">
            <el-image class="goods_img" :src="item.mainImg" fit="cover"></el-image>
          </div>
          <div class="info">
            <div class="row">
              <p class="ks_p" v-if="item.workTypeId + '' !== '1'">课时数：{{ item.totalClassHour }}</p>
              <p v-else></p>
              <p class="price">￥{{ $formatPrice(item.price) }}元</p>
            </div>
            <div class="txt_row qoverDot">
              <p>{{ item.title }}</p>
            </div>
            <div class="flex gs_desc">
              <i class="el-icon-menu b_color"></i>
              <p class="ml10 qoverDot">{{ item.className }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="bai-card mt20">
      <div class="title spaceBetween">
        <div class="flex align_center">
          <span class="gang"></span>
          <p class="txt">热门培训项目</p>
        </div>
        <p class="more more-button bai-xf" @click="jumpPage(1)">MORE+</p>
      </div>
      <div class="content product-list">
        <div class="goods_item bai-xf" v-for="(item, index) in courseList" :key="item.id">
          <div class="mask">
            <el-button type="primary" @click="jumpCouerDetalis(item)">查看课程详情</el-button>
          </div>
          <div class="img_box">
            <el-image class="goods_img" :src="item.mainImg" fit="cover"></el-image>
          </div>
          <div class="info">
            <div class="row">
              <p class="ks_p">课时数：{{ item.totalClassHour }}</p>
              <p class="price">￥{{ $formatPrice(item.price) }}元</p>
            </div>
            <div class="txt_row qoverDot">
              <p>{{ item.title }}</p>
            </div>
            <div class="flex gs_desc">
              <i class="el-icon-menu b_color"></i>
              <p class="ml10 qoverDot">{{ item.className }}</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 培训通知 -->
    <div class="bai-card mt20">
      <div class="title spaceBetween">
        <div class="flex align_center">
          <span class="gang"></span>
          <p class="txt">培训通知</p>
        </div>
        <p class="more more-button bai-xf" @click="jumpnotification">MORE+</p>
      </div>
      <div class="content news_list">
        <div class="news_item flex spaceBetween  bai-xf" @click="jumpDetails(item)" v-for="(item, index) in messageList"
          :key="index">
          <div class="flex align_center">
            <p class="kuai"></p>
            {{ item.title }}
          </div>
          <div class="time">{{ item.createTime }}</div>
        </div>
      </div>
    </div>
    <!-- 消息通知弹窗 -->
    <notification-dialog ref="notificationDialog" />
    <FeedbackPortal ref="feedbackPortalRef" />
    <div style="height: 20px;"></div>
  </div>
</template>

<script>
import NotificationDialog from '@/components/NotificationDialog.vue'
import FeedbackPortal from '@/components/FeedbackPortal.vue'
import { getMessageList, getCourseHome } from '@/api/index'
import { mapState } from 'vuex'
export default {
  name: 'HomeView',
  computed: mapState(['user']),
  components: {
    FeedbackPortal,
    NotificationDialog
  },
  data () {
    return {
      messageList: [],
      courseList: [],
      currentPage4: 4,
      did: undefined,
      resData: undefined
    }
  },
  mounted () {
    this.loadCourse()
    this.loadMessage()
    // 检查是否已在当前会话中显示过通知弹窗
    this.checkAndShowNotification()
  },
  methods: {
    openNotification () {
      this.$refs.notificationDialog.open()
    },
    // 检查并显示通知弹窗（每个会话只显示一次）
    checkAndShowNotification () {
      // 使用 sessionStorage 来控制，确保每个浏览器会话只显示一次
      const hasShownNotification = sessionStorage.getItem('hasShownNotification')

      // 如果当前会话还未显示过通知弹窗
      if (!hasShownNotification) {
        // 延迟1秒后显示，避免页面刚加载就弹出影响用户体验
        setTimeout(() => {
          this.openNotification()
          // 标记为已显示
          sessionStorage.setItem('hasShownNotification', 'true')
        }, 1000)
      }
    },
    // 页面跳转
    jumpPage (index) {
      if (!this.user.hasLogin) {
        this.$store.commit('user/SET_LOGINDIGO', true)
        return
      }
      switch (index) {
        case 1:
          this.$router.push({ path: '/training' })
          break
        case 2:
          this.$router.push({ path: '/training' })
          break
        case 3:
          this.$router.push({ path: '/user/trainRecord' })
          break
        case 4:
          this.user.groupId == 2 ? this.$router.push({ path: '/user/StudentProfile' }) : this.$router.push({ path: '/user/progress' })
          break
        case 5:
          this.$router.push({ path: '/user/order' })
          break
        case 6:
          this.$router.push({ path: '/user/invoice' })
          break
        case 7:
          this.user.groupId == 2 ? this.$router.push({ path: '/user/enterpriseSetting' }) : this.$router.push({ path: '/user/setting' })
          break
        case 8:
          this.$refs.feedbackPortalRef.open()
          break
      }
    },
    jumpnotification () {
      this.$router.push({
        path: '/notification'
      })
    },
    jumpDetails (item) {
      this.$router.push({
        path: `/notification-details?did=${item.id}`
      })
    },
    loadCourse () {
      getCourseHome({
        pageNo: 1,
        pageSize: 12
      }).then(res => {
        // this.courseList = res.data.list;
        // 根据workTypeId分组
        this.courseList = res.data.list.reduce((groups, course) => {
          const type = course.workTypeId || 0 // 默认为0（热门培训项目）
          if (!groups[type]) groups[type] = []
          groups[type].push(course)
          return groups
        }, {})
      }).catch(err => {
        this.$message.error(err.msg)
      })
    },
    // 查询消息列表
    loadMessage () {
      getMessageList({
        pageNo: 1,
        pageSize: 10
      }).then(res => {
        this.messageList = res.data.list
      }).catch(err => { })
    },
    // jumpCouerDetalis(item) {
    //   this.$router.push(`/trainingDetails?did=${item.id}`)
    // },
    jumpCouerDetalis (item) {
      // this.$router.push(`/trainingDetails?did=${item.id}`)
      // console.log(this.user.groupId);
      if (!this.user.hasLogin) {
        this.$store.commit('user/SET_LOGINDIGO', true)
        return
      }
      if (this.user.groupId == 1) { // 用户
        this.$router.push({
          name: 'apply', // 使用路由名称
          params: {
            id: item.id, // 传递的参数
            price: item.price, // 传递的参数
            title: item.title // 传递的参数
          }
        })
        // this.$router.push({
        //     path: `/apply?did=${this.did}&title=${this.resData.title}`
        // })
      } else if (this.user.groupId == 2) { // 企业
        this.$router.push({
          name: 'firmApply',
          params: {
            id: item.id
          }
        })
      }
    }
  }
}
</script>
<style lang="scss">
.form-warp {
  position: relative;
  background-color: #126fb0;
  height: 385px;

  .bg_image {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .box {
    position: absolute;
    right: 74px;
    top: 24px;
    z-index: 9;
    width: 326px;
    height: 337px;
    background: #FFFFFF;
    border-radius: 22px 22px 22px 22px;
    padding: 25px;

    .menu_name {
      text-align: center;
      font-size: 14px;
    }

    .tx_img {
      width: 51px;
      height: 51px;
      border-radius: 22px;
    }

    .info_box {
      margin-left: 15px;

      p {
        font-size: 14px;
        margin-top: 4px;
        color: #333333;
      }

    }

    .btn {
      width: 100%;
      margin-top: 18px;
    }
  }
}

.icon_menu {
  width: 55px;
  height: 55px;
}

.bz_box {
  width: 100%;
  height: 108px;
  background: #205dae;
  border-radius: 9px 9px 9px 9px;
  padding: 26px 18px;

  .el-row {
    margin: 0 auto;
  }
}

.bz_item {
  background-color: #004197;
  height: 57px;
  border-radius: 6px;
  color: #FFFFFF;
  line-height: 57px;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.bz_item_icon {
  height: 57px;
  line-height: 57px;
  color: #FFFFFF;
  font-size: 24px;
  text-align: center;
}

.news_item {
  padding: 10px 0;
}

.kuai {
  width: 7px;
  height: 7px;
  background: #205dae;
  margin-right: 10px;
}
</style>
